query AnalyticsUsersByLink($filter: AnalyticsUsersFilterInput!, $limit: Int) {
  analyticsUsers(filter: $filter) {
    usersByLink(limit: $limit) {
      linkId
      title
      users
    }
  }
}
